import { useQuery } from '@tanstack/react-query';
import {
  DepartmentSectionTypeByExternalIdsParams,
  getDepartmentSectionTypeByExternalIds,
} from '../apis/department';

export const useDepartmentSectionTypeByExternalIdsQuery = (
  params: DepartmentSectionTypeByExternalIdsParams
) => {
  return useQuery({
    queryKey: ['department-sections-type-externalIds', params.externalIds],
    queryFn: () => getDepartmentSectionTypeByExternalIds(params),
    retry: false,
    staleTime: 300000,
  });
};
